// extracted by mini-css-extract-plugin
export default {"header":"Header-module_header__R557a"};